export const documentsWasUpdatedByUser = (item ) => {
    let updatedByUserString = sessionStorage.getItem("documentsUpdatedByUser");
            let updatedByUser
            if (updatedByUserString === '' || updatedByUserString === null) {
              updatedByUser = {}
              updatedByUser[item] = true
            } else {
              updatedByUser = JSON.parse(updatedByUserString)
              updatedByUser[item] = true
            }
    sessionStorage.setItem("documentsUpdatedByUser", JSON.stringify(updatedByUser));
}

export const checkDocumentIsUpdatedByUser = (item) => {
  let updatedByUserString = sessionStorage.getItem("documentsUpdatedByUser");
          let updatedByUser
          if (updatedByUserString === '' || updatedByUserString === null) {
            return false
          } else {
            updatedByUser = JSON.parse(updatedByUserString)
            if(updatedByUser && updatedByUser[item]){
              return true
            }
          }
          return false
}

export const checkIfUserUpdatedAnyDoc = () => {
  let updatedByUserString = sessionStorage.getItem("documentsUpdatedByUser");
  let changedProfile = sessionStorage.getItem("changeProfile");
  if ((updatedByUserString === '' || updatedByUserString === null) && ( changedProfile === null || changedProfile === '')) {
    return false
  } else if (updatedByUserString !== '' && updatedByUserString !== null) {
    return true
  } else if (changedProfile !== null && changedProfile !== '') {
    return true
  } else {
    return true
  }
}